import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GetRand } from '@shared/utils/mix.utils';
import { Country, CountryISO, NgxIntlTelInputPureComponent } from 'ngx-intl-tel-input-pure';
import { startWith } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: [ './phone-input.component.scss' ]
})
export class PhoneInputComponent implements OnInit, AfterViewInit {
  @ViewChild(NgxIntlTelInputPureComponent) phoneTelInput: NgxIntlTelInputPureComponent;
  @ViewChild(NgxIntlTelInputPureComponent, { read: ElementRef }) phoneTelInputElement: ElementRef;
  @Input() control: UntypedFormControl;
  @Input() phoneCountryControl: UntypedFormControl;
  @Input() isRequired: boolean;
  @Input() allowIncorrectValue: boolean;
  countrySelected = false;
  selectedCountryISO: any = CountryISO.Russia;
  CountryISO = CountryISO;
  internalControl = new UntypedFormControl('');
  inputId = 'phoneInputId' + GetRand();
  inputClass = '';
  private currentPhoneValue: string;
  private lastKnownNumberPreffix = '';
  private inputElement: HTMLInputElement;
  private initControlDone = false;
  internalContolValue: any;

  constructor() {
  }

  ngOnInit(): void {
    if (!this.control) {
      console.error('Control not provided');
    } else {
      this.initControl(this.control);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const input = document.getElementById(this.inputId) as HTMLInputElement;
      if (input) {
        // input.addEventListener('focus', () => this.phoneInputFocused());
        this.inputElement = input;
      } else {
        console.error('Input not found', input, this.inputId);
      }
    }, 100);

    if (!this.control) {
      console.error('Control not provided');
    } else {
      this.initControl(this.control);
    }
  }

  initControl(control: UntypedFormControl) {
    if (this.initControlDone) {
      return;
    }
    this.initControlDone = true;

    this.control.valueChanges.pipe(
      untilDestroyed(this),
      startWith(this.control.value)
    ).subscribe({
      next: (data) => {
        if (this.currentPhoneValue !== data) {
          this.controlChangedOutside(data);
        }
      }
    });

    this.control.statusChanges.pipe(untilDestroyed(this)).subscribe({
      next: (data) => {
        if (data === 'INVALID') {
          this.inputClass = 'border-error';
        } else {
          this.inputClass = '';
        }
      }
    })

    const mark = control.markAsTouched;
    control.markAsTouched = () => {
      mark.call(control);
      if (this.inputElement) {
        this.inputElement.focus();
        this.inputElement.blur();
      }
    };

    this.control.setValidators(this.getValidatorFn());
    this.control.updateValueAndValidity();

    this.initPhoneInputControl();
  }

  initPhoneInputControl() {
    this.internalControl.valueChanges.subscribe({
      next: (data: { number: string; dialCode: string }) => {
        if (data) {
          const currentEnteredNumber = data.number;

          // if (this.addThisPartOnNextEnteredNumberChanging) {
          //   this.internalContolValue = currentEnteredNumber + this.addThisPartOnNextEnteredNumberChanging.toString();
          //   console.log(4444, this.inputElement.value);
          //   this.addThisPartOnNextEnteredNumberChanging = null;
          //   return;
          // }

          // console.log('Fix', currentEnteredNumber, data);
          if (currentEnteredNumber == null) {
            return;
          }
          let fixedNumber = this.fixWrongPastedNumber(currentEnteredNumber);
          // console.log('Fixed', fixedNumber);
          const maxLen = this.calculatePhoneWithCodeLength();
          fixedNumber = this.cutNumberIfLongerThenMax(fixedNumber, maxLen) || fixedNumber;

          // this.checkIfNeedChangeCountry(fixedNumber);

          this.currentPhoneValue = fixedNumber;
          if (currentEnteredNumber !== fixedNumber) {
            // console.log('set fixed to contol');
            this.internalControl.setValue(fixedNumber, { emitEvent: false });
            if (this.inputElement) {
              // console.log('set fixed to input');
              this.inputElement.value = fixedNumber;
            } else {
              console.log('No phone input element', this.inputElement);
            }
          }

          if (currentEnteredNumber === fixedNumber && maxLen && currentEnteredNumber.length === maxLen) {
            if (currentEnteredNumber.startsWith('+7') && (!currentEnteredNumber.startsWith('+76'))) {
              this.selectedCountryISO = 'RU';
            }

            // const lastLen = this.lastEnteredNumber?.length || 0;
            // if (lastLen < (currentEnteredNumber.length - 3)) {
            //   // number has been pasted, we need emulate manual typing, to fix lib's counrty detection error
            //   this.addThisPartOnNextEnteredNumberChanging = currentEnteredNumber.slice(-1);
            //   console.log(123123123, this.addThisPartOnNextEnteredNumberChanging);
            //   const cutNumber = currentEnteredNumber.slice(0, -1);
            //   this.lastEnteredNumber = cutNumber;
            //   setTimeout(() => {
            //     this.internalContolValue = cutNumber;
            //   },0)
            //   return;
            // }
          }

          // this.validate();
          if (this.control?.value !== fixedNumber) {
            this.control.setValue(fixedNumber);
            this.control.updateValueAndValidity();
            // this.phoneCountryControl?.setValue(data.dialCode || '--');
          }
        }
      }
    });
  }

  controlChangedOutside(value: string) {
    if (!value) {
      return;
    }
    this.currentPhoneValue = value;
    if (value.length > 1) {
      this.lastKnownNumberPreffix = value.substr(0, 2);
    }
    this.internalControl.setValue(this.currentPhoneValue);
  }

  countryChanged(country: Country) {
    // console.log('@@@@@@', country.iso2, this.selectedCountryISO);
    if (country.dialCode && this.selectedCountryISO !== country.iso2) {
      this.countrySelected = true;
      this.lastKnownNumberPreffix = '+' + country.dialCode;
      // this.phoneInputControl.setValue('+' + country.dialCode);
      this.selectedCountryISO = country.iso2;
      // if (this.phoneCountryControl && this.phoneCountryControl.value !== country.iso2) {
      //   this.phoneCountryControl.setValue(country.iso2);
      // }
    }
  }

  private fixWrongPastedNumber(value: string) {
    if (!value?.length) {
      return value;
    }
    let result = this.clearPhone(value);
    if (result.substr(0, 1) === '+') {
      return result;
    }
    if (value.substr(0, 1) === '8') {
      result = '+7' + result.substr(1);
      return result;
    }
    return '+' + result;
  }

  private getCurrentPhoneNumber(): string {
    return this.internalControl.value?.number || '';
    // const country = this.getCurrentCountry();
    // if (!country || !this.phoneControl.value?.number) {
    //   return '';
    // }
    // return `+${country.dialCode}${this.phoneControl.value.number}`;
  }

  private getCurrentCountry() {
    // console.log(this.phoneTelInput?.selectedCountry);
    return this.phoneTelInput?.selectedCountry;
  }

  private getIntlTelInputError() {
    return this.phoneTelInput.selectedCountry;
  }

  private getValidatorFn(): ValidatorFn {
    const req = { required: true };
    const checkIfValid = (value: string): ValidationErrors | null => {
      const len = this.calculatePhoneWithCodeLength();
      if (len) {
        if (value.length === len) {
          return null;
        } else {
          return { default: true };
        }
      } else {
        return null;
      }
    }
    return (control) => {
      // console.log('Run Validation', control.value);
      if (!this.isRequired && this.allowIncorrectValue) {
        return null;
      }
      if (this.isRequired && this.allowIncorrectValue && control.value) {
        return null;
      }
      if (this.isRequired) {
        if (!control.value) {
          return req;
        } else {
          if (this.allowIncorrectValue) {
            return null;
          } else {
            return checkIfValid(control.value);
          }
        }
      } else {
        if (!control.value) {
          return null;
        } else {
          if (this.allowIncorrectValue) {
            return null;
          } else {
            return checkIfValid(control.value);
          }
        }
      }
    }
  }

  private validate() {
    // this.updateControlValidators();
    // const value = this.phoneInputControl.value?.number || '';
    // if (this.validation === 'all' && !value) {
    //   this.setValidationState(false);
    //   return;
    // }
    // if (this.validation === 'off') {
    //   this.setValidationState(true);
    //   return;
    // }
    // if (value.length !== this.calculatePhoneWithoutCodeLength()) {
    //   if (this.validation === 'onlyIncorrect' && value.length === 0) {
    //     this.setValidationState(true);
    //     return;
    //   }
    //   this.setValidationState(false);
    // } else {
    //   this.setValidationState(true);
    // }
  }

  private cutNumberIfLongerThenMax(value: string, maxLen) {

    if (maxLen < 8) {
      return null;
    }
    // console.log('Max len for ', this.getCurrentCountry().name, maxLen, value);
    if (value?.length > maxLen) {
      return value.substr(0, maxLen);
    }
    return value;
  }

  private calculatePhoneWithCodeLength() {
    const country = this.getCurrentCountry();
    // console.log(country);
    if (!country) {
      this.setValidationState(false);
      return null;
    }
    const phonePlaceholder = this.clearPhone(country.placeHolder); //.replace('+', '');
    // console.log(phonePlaceholder, phonePlaceholder.length, country.dialCode, country.dialCode.length);
    return phonePlaceholder.length; // - country.dialCode?.length;
  }

  private clearPhone(phone: string) {
    if (!phone) {
      return '';
    }
    return phone.replace(/\s/g, '').replace(/-/g, '');
  }

  private setValidationState(valid: boolean) {
    // this.control.setErrors(valid ? null : { wrongValue: true });
    // console.log(this.control.errors);
    // this.control.updateValueAndValidity();
    // console.log();
    // this.inputClass = valid ? 'ng-valid ttt_valid' : 'mat-form-field-invalid ttt_invalid';

    if (this.phoneTelInputElement?.nativeElement) {
      console.dir(this.phoneTelInputElement.nativeElement);
      if (valid) {
        this.phoneTelInputElement.nativeElement.classList.remove('mat-form-field-invalid');
      } else {
        this.phoneTelInputElement.nativeElement.classList.add('mat-form-field-invalid');
      }
    }

    // setTimeout(() => {
    //   console.log(this.phoneInput.cssClass);
    // }, 500);
  }

  private createValidatorFn(phoneLength: number): ValidatorFn {
    return (control: AbstractControl) => {
      if (control?.value && control.value.length !== phoneLength) {
        return { wrongValue: true };
      } else {
        return null;
      }
    }
  }

  private updateControlValidators() {
    // const validators = [];
    // if (this.validation !== 'off') {
    //   const length = this.calculatePhoneWithoutCodeLength();
    //   validators.push(this.createValidatorFn(length))
    // }
    // if (this.validation === 'all') {
    //   validators.push(Validators.required);
    // }
    // if (this.control) {
    //   setTimeout(() => {
    //     this.control.setValidators(validators);
    //   }, 0)
    // }
  }

  private checkIfNeedChangeCountry(fixedNumber: string) {
    console.log(this.lastKnownNumberPreffix, fixedNumber.startsWith(this.lastKnownNumberPreffix));
    if (this.lastKnownNumberPreffix) {
      if (!fixedNumber.startsWith(this.lastKnownNumberPreffix)) {
        this.selectedCountryISO = null;
        this.countrySelected = false;
      }
    }
  }

  test() {
    console.log(this.selectedCountryISO);
    console.log(this.internalControl.value);
  }

  phoneInputFocused() {
    if (!this.control.touched) {
      this.control.markAsTouched();
      this.inputElement.focus();
    }
  }
}
